module.exports = __webpack_public_path__ + "img/Speaker2.cebb8660.jpeg";